<template>
    <div id="main">
        <loader v-if="isLoading" />
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t("vincular-prazo-pagamento") }}
                </h1>
            </div>
            <div class="header-buttons">
                <button 
                    class="delete-btn" 
                    type="button" 
                    @click="fecharModal()"
                >
                    {{ $t("cancelar") }}
                </button>
                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="prazoPagamentoSelecionados.length === 0"
                >
                    {{ $t("salvar") }}
                </button>
            </div>
        </div>
        <br/>
        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                />
            </div>
        </div>
        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="usuarios"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="prazoPagamentoSelecionados"
                :custom-is-checked="(selecionados, linha) => selecionados.idprazopagto === linha.idprazopagto"
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    v-slot="props"
                >
                    <span>{{ props.row[f.key] }}</span>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
import AssPrazoPagamentoCliente from '@/services/vendas/cliente/abas/AssPrazoPagamentoClienteService';

/* @70957 */
export default {
    props: {
        idCliente: 0,
    },
    data() {
        return {
            assService: new AssPrazoPagamentoCliente(this.$http, this.$router),
            usuarios: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'descricao', width: null, sortable: true }
            ],
            prazoPagamentoSelecionados: [],
            idprazopagto: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'descricao',
            order: 'asc',
            msgs: [],
            isVenda: this.$route.meta.contexto == "vendas",
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[
            this.pagination.optionStarted
        ];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }
            this.isLoading = true;
            this.findNaoAssociados(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.idCliente,
                this.queryFilter
            )
            .then(this.mapItems)
            .then(value => {
                this.usuarios = value;
                this.isEmpty = this.usuarios.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },
        findNaoAssociados(column, order, page, limit, idcliente, ...params) {
            if(this.isVenda) {
                return this.assService
                .findNaoAssociadosVendas(column, order, page, limit, idcliente, ...params);
            }else {
                return this.assService
                .findNaoAssociadosAgro(column, order, page, limit, idcliente, ...params);
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idcliente: +this.idCliente,
                    idprazopagto: m.idprazopagto,
                    descricao: m.descricao,
                    idassprazopagtocliente: null
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.prazoPagamentoSelecionados.length > 0) {
                this.isLoading = true;
                
                this.savePP()
                .then(value => {
                    if (value.content === null) {
                        this.msgs.push(new Message("error", `${value.message}`, true));
                    } else {
                        this.$emit('fecharModal', true);
                        this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                    }
                })
                .catch(() => {
                    this.msgs.push(new Message("alert", 'msg-erro-load', true));
                })
                .finally(() => {
                    this.isLoading = false;
                });
            } else {
                this.msgs.push(new Message("error", 'msg-selecione-prazo-pagamento', true));
                this.isLoading = false;
            }
        },
        savePP() {
            if(this.isVenda) return this.assService.saveVendas(this.prazoPagamentoSelecionados);
            else return this.assService.saveAgro(this.prazoPagamentoSelecionados);
        },
        fecharModal() {
              this.$emit("fecharModal", true);
        },
    },
}
</script>
<style lang="scss" scoped>
#main {
    padding: 20px 20px;
    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
